<template>
  <a-spin :spinning="spinning">
    <div class="">
      <a-tabs v-model="activeTab" @change="handleTabChange">
        <a-tab-pane key="export" tab="导出任务">
          <div class="tk_table">
            <ele-table ref="rtExport" :columns="exportColumns" :table-data="exportTableData" :total-items="exportTotalItems" :is-full="true"
              :actionsType="exportActionsType" :current-page="exportPageNumber" :hide-row-selection="false"
              @emitOnPageChange="updateExportPageChange" @emitShowSizeChange="updateExportShowSizeChange">
              <!-- 按钮 -->
              <a-row :gutter="24">
                <a-col :span="4">
                  <a-input v-model="exportSearchDto.Filter" :placeholder="l('任务编码')" />
                </a-col>
                <a-col :span="5">
                  <a-button type="primary" @click="getExportData" v-if="isGranted('Pages.ExportTask.Query')">
                    <a-icon type="search" /> {{ l("搜索") }}
                  </a-button>
                  <a-button @click="clearExportFilterAndRefresh">
                    {{ l("重置") }}
                  </a-button>
                </a-col>
              </a-row>
            </ele-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="import" tab="导入任务">
          <div class="tk_table">
            <ele-table ref="rtImport" :columns="importColumns" :table-data="importTableData" :total-items="importTotalItems" :is-full="true"
              :actionsType="importActionsType" :current-page="importPageNumber" :hide-row-selection="false"
              @emitOnPageChange="updateImportPageChange" @emitShowSizeChange="updateImportShowSizeChange">
              <!-- 按钮 -->
              <a-row :gutter="24">
                <a-col :span="4">
                  <a-input v-model="importSearchDto.Filter" :placeholder="l('任务编码')" />
                </a-col>
                <a-col :span="5">
                  <a-button type="primary" @click="getImportData" v-if="isGranted('Pages.ExportTask.Query')">
                    <a-icon type="search" /> {{ l("搜索") }}
                  </a-button>
                  <a-button @click="clearImportFilterAndRefresh">
                    {{ l("重置") }}
                  </a-button>
                </a-col>
              </a-row>
            </ele-table>
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>
  </a-spin>
</template>

<script>
import { AppComponentBase } from "@/shared/component-base";
import EleTable from "@/components/ele-table";
import moment from "moment";
import { fileDownloadService } from "@/shared/utils";

export default {
  mixins: [AppComponentBase],
  name: "ExportTaskIndex",
  components: { EleTable },
  data: function () {
    return {
      activeTab: "export",
      // 导出任务相关
      exportColumns: [],
      exportTableData: [],
      exportActionsType: null,
      exportTotalItems: 0,
      exportPageNumber: 0,
      exportSearchDto: {
        Filter: '',
        SkipCount: 0,
        MaxResultCount: 50
      },
      // 导入任务相关
      importColumns: [],
      importTableData: [],
      importActionsType: null,
      importTotalItems: 0,
      importPageNumber: 0,
      importSearchDto: {
        Filter: '',
        SkipCount: 0,
        MaxResultCount: 50
      },
      spinning: false,
      pagerange: [],
    };
  },
  methods: {
    handleTabChange (activeKey) {
      this.activeTab = activeKey;
      if (activeKey === "export") {
        if (this.exportTableData.length === 0) {
          this.initExportTable();
          this.getExportData();
        }
      } else if (activeKey === "import") {
        if (this.importTableData.length === 0) {
          this.initImportTable();
          this.getImportData();
        }
      }
    },
    // ========== 导出任务相关方法 ==========
    updateExportPageChange (newV) {
      let { page, pageSize } = newV;
      this.exportPageNumber = page;
      this.exportSearchDto.SkipCount = (page - 1) * this.exportSearchDto.MaxResultCount;
      this.getExportData();
    },
    updateExportShowSizeChange (newV) {
      let { current, size } = newV;
      this.exportPageNumber = 1;
      this.exportSearchDto.MaxResultCount = size;
      this.getExportData();
    },
    clearExportFilterAndRefresh () {
      this.exportSearchDto.Filter = '';
      this.exportPageNumber = 1;
      this.exportSearchDto.SkipCount = 0;
      this.getExportData();
    },
    getExportData () {
      this.spinning = true;
      this.$api.request({
        url: this.$apiUrl + "/api/services/app/ExportTask/GetPages",
        method: "POST",
        data: {
          TaskCode: this.exportSearchDto.Filter,
          SkipCount: this.exportSearchDto.SkipCount,
          MaxResultCount: this.exportSearchDto.MaxResultCount
        },
        headers: { "Content-Type": "application/json-patch+json" },
      }).then((res) => {
        this.spinning = false;
        if (res.status === 200) {
          let data = res.data;
          this.exportTotalItems = data.totalCount;
          this.totalPages = Math.ceil(
            data.totalCount / this.exportSearchDto.MaxResultCount
          );
          this.pagerange = [
            (this.exportPageNumber - 1) * this.exportSearchDto.MaxResultCount + 1,
            this.exportPageNumber * this.exportSearchDto.MaxResultCount,
          ];
          this.exportTableData = data.items.map(item => {
            return {
              ...item,
              taskResultStr: this.getTaskResult(item.taskResult),
              creationTimeStr: `${moment(item.creationTime).format("YYYY-MM-DD")}`,
              sourceStr: this.getTaskSource(item.source),
              startTimeStr: `${item.startTime ? item.startTime.replace("T", " ") : ""}`,
              endTimeStr: `${item.endTime ? item.endTime.replace("T", " ") : ""}`
            }
          });
        } else {
          abp.message.warn(this.l("DefaultErrorMessage"));
        }
      }).catch(() => {
        this.spinning = false;
      });
    },
    initExportTable () {
      const that = this;
      this.exportColumns = [
        {
          title: "任务名称",
          dataIndex: "taskName",
          sorter: false,
          align: "center",
          scopedSlots: { customRender: "taskName" },
        },
        {
          title: "任务编码",
          dataIndex: "taskCode",
          sorter: false,
          align: "center",
          scopedSlots: { customRender: "taskCode" },
        },
        {
          title: "导出结果",
          dataIndex: "taskResultStr",
          sorter: false,
          align: "center",
          scopedSlots: { customRender: "taskResultStr" },
        },
        {
          title: "创建人",
          dataIndex: "creator",
          sorter: false,
          align: "center",
          scopedSlots: { customRender: "creator" },
        },
        {
          title: "创建时间",
          dataIndex: "creationTimeStr",
          sorter: false,
          align: "center",
          scopedSlots: { customRender: "creationTimeStr" },
        },
        {
          title: "来源",
          dataIndex: "sourceStr",
          sorter: false,
          align: "center",
          scopedSlots: { customRender: "sourceStr" },
        },
        {
          title: "开始时间",
          dataIndex: "startTimeStr",
          sorter: false,
          align: "center",
          scopedSlots: { customRender: "startTimeStr" },
        },
        {
          title: "结束时间",
          dataIndex: "endTimeStr",
          sorter: false,
          align: "center",
          scopedSlots: { customRender: "endTimeStr" },
        },
        {
          title: this.l("Action"),
          dataIndex: "actions",
          align: "center",
          fixed: "right",
          scopedSlots: { customRender: "actions" },
        }
      ];
      let _this = this;
      this.exportActionsType = {
        type: "export-task",
        isShow: true,
        fns: {
          detailList: [
            {
              granted: this.isGranted("Pages.ExportTask.Query"),
              name: this.l("下载"),
              icon: "download",
              fn: (data) => {
                if (data.downloadUrl && data.downloadUrl.indexOf('http') === 0) {
                  window.location.href = data.downloadUrl;
                } else if (data.downloadUrl) {
                  const url = `${this.$apiUrl}/api/services/app/ExportTask/DownloadFile?id=${data.id}&tenantId=${data.tenantId}`;
                  window.open(url);
                }
              },
              EnableFunc (row) {
                return row.taskResult !== 2;
              }
            },
          ]
        }
      }
    },
    // ========== 导入任务相关方法 ==========
    updateImportPageChange (newV) {
      let { page, pageSize } = newV;
      this.importPageNumber = page;
      this.importSearchDto.SkipCount = (page - 1) * this.importSearchDto.MaxResultCount;
      this.getImportData();
    },
    updateImportShowSizeChange (newV) {
      let { current, size } = newV;
      this.importPageNumber = 1;
      this.importSearchDto.MaxResultCount = size;
      this.getImportData();
    },
    clearImportFilterAndRefresh () {
      this.importSearchDto.Filter = '';
      this.importPageNumber = 1;
      this.importSearchDto.SkipCount = 0;
      this.getImportData();
    },
    getImportData () {
      this.spinning = true;
      this.$api.request({
        url: this.$apiUrl + "/api/services/app/ExportTask/GetPages",
        method: "POST",
        data: {
          TaskCode: this.importSearchDto.Filter,
          SkipCount: this.importSearchDto.SkipCount,
          MaxResultCount: this.importSearchDto.MaxResultCount,
          isImport: true
        },
        headers: { "Content-Type": "application/json-patch+json" },
      }).then((res) => {
        this.spinning = false;
        if (res.status === 200) {
          let data = res.data;
          this.importTotalItems = data.totalCount;
          this.totalPages = Math.ceil(
            data.totalCount / this.importSearchDto.MaxResultCount
          );
          this.pagerange = [
            (this.importPageNumber - 1) * this.importSearchDto.MaxResultCount + 1,
            this.importPageNumber * this.importSearchDto.MaxResultCount,
          ];
          this.importTableData = data.items.map(item => {
            return {
              ...item,
              taskResultStr: this.getTaskResult(item.taskResult),
              creationTimeStr: `${moment(item.creationTime).format("YYYY-MM-DD")}`,
              sourceStr: this.getTaskSource(item.source),
              startTimeStr: `${item.startTime ? item.startTime.replace("T", " ") : ""}`,
              endTimeStr: `${item.endTime ? item.endTime.replace("T", " ") : ""}`
            }
          });
        } else {
          abp.message.warn(this.l("DefaultErrorMessage"));
        }
      }).catch(() => {
        this.spinning = false;
      });
    },
    initImportTable () {
      this.importColumns = [
        {
          title: "任务名称",
          dataIndex: "taskName",
          sorter: false,
          align: "center",
          scopedSlots: { customRender: "taskName" },
        },
        {
          title: "任务编码",
          dataIndex: "taskCode",
          sorter: false,
          align: "center",
          scopedSlots: { customRender: "taskCode" },
        },
        {
          title: "执行结果",
          dataIndex: "taskResultStr",
          sorter: false,
          align: "center",
          scopedSlots: { customRender: "taskResultStr" },
        },
        {
          title: "失败原因",
          dataIndex: "reason",
          sorter: false,
          align: "center",
          scopedSlots: { customRender: "reason" },
        },
        {
          title: "创建人",
          dataIndex: "creator",
          sorter: false,
          align: "center",
          scopedSlots: { customRender: "creator" },
        },
        {
          title: "创建时间",
          dataIndex: "creationTimeStr",
          sorter: false,
          align: "center",
          scopedSlots: { customRender: "creationTimeStr" },
        },
        {
          title: "来源",
          dataIndex: "sourceStr",
          sorter: false,
          align: "center",
          scopedSlots: { customRender: "sourceStr" },
        },
        {
          title: "开始时间",
          dataIndex: "startTimeStr",
          sorter: false,
          align: "center",
          scopedSlots: { customRender: "startTimeStr" },
        },
        {
          title: "结束时间",
          dataIndex: "endTimeStr",
          sorter: false,
          align: "center",
          scopedSlots: { customRender: "endTimeStr" },
        },
        {
          title: this.l("Action"),
          dataIndex: "actions",
          align: "center",
          fixed: "right",
          scopedSlots: { customRender: "actions" },
        }
      ];
      let _this = this;
      this.importActionsType = {
        type: "import-task",
        isShow: true,
        fns: {
          detailList: [
            {
              granted: true,
              name: this.l("导入文件"),
              icon: "download",
              fn: (data) => {
                console.warn('data',data);
                if (data.importUrl && data.importUrl.indexOf('http') >= 0) {
                  window.open(data.importUrl);
                }
              },
              EnableFunc (row) {
                // 如果 importUrl 为空，则按钮不可用
                return !row.importUrl || row.importUrl == '';
              }
            },
            {
              granted: this.isGranted("Pages.ExportTask.Query"),
              name: this.l("异常文件"),
              icon: "file-exclamation",
              fn: (data) => {
                if (data.downloadUrl && data.downloadUrl.indexOf('http') >= 0) {
                  window.open(data.downloadUrl);
                }
              },
              EnableFunc (row) {
                // 只有当结果为失败时才显示
                return row.taskResult != 3;
              }
            },
            {
              granted: this.isGranted("Pages.ExportTask.Query"),
              name: this.l("重试"),
              icon: "reload",
              fn: (data) => {
                _this.reExecuteImportTask(data.id);
              },
              EnableFunc (row) {
                // 只有结果为失败的记录才允许操作（taskResult === 3 表示失败）
                return row.taskResult != 3;
              }
            },
          ]
        }
      }
    },
    // ========== 通用方法 ==========
    getTaskResult (result) {
      switch (result) {
        case 0:
          return "未开始";
        case 1:
          return "处理中";
        case 2:
          return "成功";
        case 3:
          return "失败";
        default:
          return "";
      }
    },
    getTaskSource (source) {
      switch (source) {
        case 1:
          return "项目人员";
        case 2:
          return "人员管理";
        case 3:
          return "发放明细";
        case 4:
          return "发放汇总";
        default:
          return "";
      }
    },
    // 重试导入任务
    reExecuteImportTask (id) {
      this.spinning = true;
      this.$api.request({
        url: this.$apiUrl + `/api/services/app/ExportTask/ReExecute?id=${id}`,
        method: "GET",
        headers: { "Content-Type": "application/json-patch+json" },
      }).then((res) => {
        this.spinning = false;
        if (res.status === 200) {
          abp.message.success(this.l("重试成功"));
          // 刷新导入任务列表数据
          this.getImportData();
        } else {
          abp.message.error(res.statusText || this.l("重试失败"));
        }
      }).catch((error) => {
        this.spinning = false;
        abp.message.error(this.l("重试失败"));
        console.error(error);
      });
    }
  },
  created () {
    this.initExportTable();
    this.getExportData();
  },
};
</script>
